import React, { useEffect, useState } from "react";
import { useStore } from "@/store/StoreContext";
import { imgSrc } from "@/lib/api";

export default function BannerSlider() {
  const { banners, setBannerIdx } = useStore();
  const [active, setActive] = useState(0);

  useEffect(() => {
    setBannerIdx(active);
  }, [active, setBannerIdx]);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const t = setInterval(() => setActive((a) => (a + 1) % banners.desktop.length), 3200);
    return () => clearInterval(t);
  }, [banners.desktop.length]);

  return (
    <section id="top" data-testid="hero" className="relative w-full bg-[#120C06]">
      {/* desktop banners — exact uploaded proportions, never cropped */}
      <div className="relative hidden w-full sm:block" style={{ aspectRatio: "1920 / 814" }}>
        {banners.desktop.map((b, i) => (
          <img
            key={b.src}
            src={imgSrc(b.src)}
            alt={b.alt}
            data-testid={`banner-slide-${i}`}
            className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-[900ms] ease-in-out ${i === active ? "opacity-100" : "opacity-0"}`}
            loading={i === 0 ? "eager" : "lazy"}
          />
        ))}
      </div>
      {/* mobile banners — natural uploaded size, never cropped */}
      <div className="grid w-full sm:hidden">
        {banners.mobile.map((b, i) => (
          <img
            key={b.src}
            src={imgSrc(b.src)}
            alt={b.alt}
            data-testid={`banner-slide-mobile-${i}`}
            className={`col-start-1 row-start-1 w-full object-contain transition-opacity duration-[900ms] ease-in-out ${i === active ? "opacity-100" : "opacity-0"}`}
            loading={i === 0 ? "eager" : "lazy"}
          />
        ))}
      </div>
      {/* slide dots */}
      <div className="absolute bottom-3 left-1/2 z-10 flex -translate-x-1/2 gap-2 sm:bottom-5">
        {banners.desktop.map((_, i) => (
          <button
            key={i}
            data-testid={`banner-dot-${i}`}
            onClick={() => setActive(i)}
            aria-label={`Banner ${i + 1}`}
            className={`h-2 rounded-full transition-all duration-500 ${i === active ? "w-7 bg-[#D4AF37]" : "w-2 bg-white/60 hover:bg-white"}`}
          />
        ))}
      </div>
    </section>
  );
}
